import { i18n } from '@/plugins/element'
const { t } = i18n.global

const sceneOptions = [
  {
    id: 'dr',
    name: t('license.dr')
  },
  {
    id: 'migration',
    name: t('license.migration')
  }
]
export {
  sceneOptions
}